var map = {
	"./Astucia.svg": 8922,
	"./CalibrationSettings.png": 4000,
	"./Chase.svg": 8768,
	"./Feflex.svg": 925,
	"./Flex.svg": 930,
	"./Logo.svg": 3630,
	"./Recurso 10.svg": 3336,
	"./Recurso 11.svg": 3519,
	"./Recurso 12.svg": 2125,
	"./Recurso 13.svg": 8634,
	"./Recurso 14.svg": 5825,
	"./Recurso 15.svg": 8347,
	"./Recurso 16.svg": 1702,
	"./Recurso 3.svg": 6799,
	"./Recurso 5.svg": 1674,
	"./Recurso 6.svg": 707,
	"./Recurso 7.svg": 5674,
	"./Recurso 8.svg": 6430,
	"./Recurso 9.svg": 5272,
	"./Recurso-2.svg": 7164,
	"./Recurso-4.svg": 8148,
	"./Relax Icon.svg": 1468,
	"./Smooth_background_blur_1.jpg": 6196,
	"./Smooth_background_blur_1_gold.png": 3399,
	"./Stamina Challenge.svg": 9484,
	"./TRACKING OPTION 1.png": 9944,
	"./TRACKING OPTION 2.png": 6050,
	"./VERGENCE ICON.png": 6788,
	"./category/Focusing.png": 5626,
	"./category/Focusing.svg": 2926,
	"./category/Synching.png": 7472,
	"./category/Synching.svg": 4278,
	"./category/visionStamina-edited.png": 6672,
	"./elipses.png": 1166,
	"./games/Astucia.svg": 6909,
	"./games/Chase.svg": 1520,
	"./games/Flex.svg": 4006,
	"./games/Reflex.svg": 3532,
	"./games/Relax.svg": 912,
	"./games/StaminaChallenge.svg": 7137,
	"./id.png": 8536,
	"./instructions/Asset-31.svg": 3731,
	"./instructions/Asset-33.svg": 6719,
	"./instructions/Destroyer - Split.svg": 4960,
	"./instructions/Destroyer - left right.svg": 8190,
	"./instructions/Destroyer - pop out.svg": 2597,
	"./instructions/Destroyer - shoot.svg": 7872,
	"./instructions/Diamonds - Arrow keys.svg": 7119,
	"./instructions/Diamonds - Split.svg": 6682,
	"./instructions/Diamonds - pop out.svg": 4854,
	"./instructions/Focusing - Math.svg": 911,
	"./instructions/Focusing - QR.svg": 4062,
	"./instructions/Focusing - Symbols.svg": 2158,
	"./instructions/HammerAlien.svg": 6146,
	"./instructions/Recurso 15.svg": 4130,
	"./instructions/Recurso 16.svg": 7170,
	"./instructions/Recurso-11.svg": 1522,
	"./instructions/Recurso-20.svg": 9062,
	"./instructions/Recurso-27.svg": 1907,
	"./instructions/Recurso-9.svg": 737,
	"./instructions/Ship-Shoot-1.svg": 363,
	"./instructions/Ship-Shoot-2.svg": 1144,
	"./instructions/Smasher - hammer.svg": 892,
	"./instructions/Synching - arrow keys.svg": 9614,
	"./instructions/Synching - moving arrow.svg": 4304,
	"./instructions/accommodationAll_instruction_2.svg": 4573,
	"./instructions/accommodationColor_instruction_3.svg": 5897,
	"./instructions/accommodationCrossfire_instruction_3.svg": 1181,
	"./instructions/accommodationMath_instruction_3.svg": 5040,
	"./instructions/accommodationPicture_instruction_3.svg": 2638,
	"./instructions/accommodationSymbol_instruction_3.svg": 7355,
	"./instructions/all_instruction_1.svg": 8014,
	"./instructions/tracking2_instruction_3.svg": 2562,
	"./instructions/tracking_instruction_2.svg": 7865,
	"./instructions/tracking_instruction_3.svg": 4015,
	"./instructions/tracking_instruction_4.svg": 3666,
	"./instructions/vergence_instruction_2.svg": 4144,
	"./instructions/vergence_instruction_4.svg": 5146,
	"./logo.png": 6949,
	"./visionStamina.png": 7759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;